import React, { useState, useCallback, useEffect } from 'react';

import FormContents from 'components/atoms/Form/FormContents';
import PrimaryButton from 'components/atoms/Button';
import { exportFilePDF } from 'api/attendAchievementOutput';
import moment from 'moment';
import { useGetSupportSourceOrg, downloadOriginalPDF } from './hooks';
import useToastNotification from 'hooks/useToastNotification';
import FormPadding from 'components/atoms/Form/FormPadding';
import CalendarForm from 'components/molecules/CalendarForm';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import { Row, Col } from 'react-grid-system';
import { css } from '@emotion/core';
import { grayScale, textFontSize } from 'components/styles';
import BlockUI from 'components/molecules/BlockUi';
import FormHeader from 'components/templates/FormHeader';
import SelectForm from 'components/molecules/SelectForm';
import ClickableIconButton from 'components/atoms/ClickableIconButton';
import Icon from 'components/atoms/Icon';
import FlexBox from 'components/atoms/FlexBox';
import FormLabel from 'components/atoms/Form/FormLabel';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';

const AttendHelpLayoutList: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const orgCode = !sessionStorage.getItem('orgCode') ? sessionStorage.getItem('loginUser.orgCode') : sessionStorage.getItem('orgCode');
  const [getSupportSourceOrg, setSupportSourceOrg] = useState(orgCode);
  const [targetDate, setTargetDate] = useState(sessionStorage.getItem('targetDate') || new Date());
  const { organizationsTrees } = useGetSupportSourceOrg();
  const { errorNotification } = useToastNotification();

  const handleClick = useCallback(() => {
    setIsLoading(false);
    exportFilePDF(getSupportSourceOrg, moment(targetDate).format("YYYY-MM-01")).then((response: any) => {
      setIsLoading(true);
      downloadOriginalPDF(response, '勤怠実績出力.pdf');
    }).catch((error) => {
      setIsLoading(true);
      errorNotification('対象月、対象組織において在籍するスタッフがいませんでした。');
    })
  }, [getSupportSourceOrg, errorNotification, targetDate]);

  useEffect(() => {
  }, [isLoading])

  // const handleClickCSVDay = useCallback(() => {
  //   setIsLoading(false);
  //   exportFileCSVDay(getSupportSourceOrg, setDate).then((response: any) => {
  //     setIsLoading(true);
  //   }).catch((error) => {
  //     setIsLoading(true);
  //     errorNotification('対象月、対象店舗において在籍するスタッフがいませんでした。');
  //   })
  // }, [getSupportSourceOrg, errorNotification, setIsLoading, setDate]);

  // const handleClickCSVTime = useCallback(() => {
  //   setIsLoading(false);
  //   exportFileCSVTime(getSupportSourceOrg, setDate).then((response: any) => {
  //     setIsLoading(true);
  //   }).catch((error) => {
  //     setIsLoading(true);
  //     errorNotification('対象月、対象店舗において在籍するスタッフがいませんでした。');
  //   })
  // }, [getSupportSourceOrg, errorNotification, setIsLoading, setDate]);

  const style = {
    color: `${grayScale.gray60}`,
    fontSize: `${textFontSize.re}`
  };

  return (
    <div>
      <BlockUI blocking={!isLoading}>
        <FormHeader title="勤怠実績印刷" />
        <FormContents customStyle={css({ marginTop: '60px' })}>
          <FormPadding customStyle={css({ marginTop: '8px' })}>
            <Row>
              <Col xl={6} md={12} xs={12}>
                <FlexBox>
                  <FlexBoxItem width="100px">
                    <FormLabel label="営業月" customStyle={css({ width: '100px', margin: '0' })} />
                  </FlexBoxItem>
                  <FlexBoxItem>
                    <FlexBox>
                      <FlexBoxItem>
                        <CalendarMonth
                        openActionChevron={true} 
                        date={new Date(targetDate)}
                        setDate={(date: Date) => {
                          sessionStorage.setItem('targetDate', String(date));
                          setTargetDate(date);
                        }}
                        />
                      </FlexBoxItem>
                      {/* <FlexBoxItem customStyle={css({ marginLeft: '-35px' })}>
                        <ClickableIconButton onClick={() => {
                          setTargetDate(new Date(moment(targetDate).subtract(1, 'month').format('YYYY/MM/01')));
                          sessionStorage.setItem('targetDate', moment(targetDate).subtract(1, 'month').format('YYYY/MM/01'));
                        }}>
                          <Icon type="chevronLeft" color="" size="24px" />
                        </ClickableIconButton>
                      </FlexBoxItem>
                      <FlexBoxItem width="160px">
                        <CalendarForm
                          label=""
                          date={new Date(targetDate)} dateFormat="YYYY/MM"
                          changeDate={(date: Date) => {
                            sessionStorage.setItem('targetDate', String(date));
                            setTargetDate(date);
                          }}
                        />
                      </FlexBoxItem>
                      <FlexBoxItem>
                        <ClickableIconButton onClick={() => {
                          setTargetDate(new Date(moment(targetDate).add(1, 'month').format('YYYY/MM/01')));
                          sessionStorage.setItem('targetDate', moment(targetDate).add(1, 'month').format('YYYY/MM/01'));
                        }}>
                          <Icon type="chevronRight" color="" size="24px" />
                        </ClickableIconButton>
                      </FlexBoxItem> */}
                    </FlexBox>
                  </FlexBoxItem>
                </FlexBox>
              </Col>
            </Row>
          </FormPadding>
          <FormPadding>
            <Row >
              <Col xl={6} md={12} xs={12}>
                <FlexBox>
                  <FlexBoxItem width="100px">
                    <FormLabel label="組織" customStyle={css({ width: '100px', margin: '0' })} />
                  </FlexBoxItem>
                  <FlexBoxItem width={"480px"}>
                    <SelectForm
                      label=""
                      name="orgCode"
                      value={String(getSupportSourceOrg)}
                      setValue={(val: string) => setSupportSourceOrg(val)}
                      options={organizationsTrees}
                      required={false}
                    />
                  </FlexBoxItem>
                </FlexBox>
              </Col>
            </Row>
          </FormPadding>

          <div style={{ paddingTop: '16px', paddingBottom:'16px', marginBottom:'9px', textAlign: 'center' }}>
              <PrimaryButton
                ghost={false}
                text="印刷"
                onClick={handleClick}
                customStyle={css({
                  marginRight: '5px'
                })}
              />
            
            </div>
        </FormContents>
      </BlockUI>
    </div >
  );
};

export default AttendHelpLayoutList;
